import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Notice the child",
    opening: localizedGenderNode(
      [
      "Today I don't try to fix.",
      "I just notice the inner child.",
      "That is enough for now."
    ],
      [
      "Today I don't try to fix.",
      "I just notice the inner child.",
      "That is enough for now."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When does this child wake up in me?",
      "What is happening around me then?",
      "How does it feel in my body?"
    ],
      [
      "When does this child wake up in me?",
      "What is happening around me then?",
      "How does it feel in my body?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Noticing is already a small hug."
    ],
      [
      "Noticing is already a small hug."
    ]
    ),
    action: localizedGenderNode(
      "one breath with the words \"I am here\".",
      "one breath with the words \"I am here\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "What it needs",
    opening: localizedGenderNode(
      [
      "Today I notice what the child needs.",
      "No promises.",
      "Just to see."
    ],
      [
      "Today I notice what the child needs.",
      "No promises.",
      "Just to see."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "I feel my chest."
    ],
      [
      "I breathe slowly.",
      "I feel my chest."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What was missing for it then?",
      "What does it ask from me today?",
      "What is hard for me to give it?"
    ],
      [
      "What was missing for it then?",
      "What does it ask from me today?",
      "What is hard for me to give it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Seeing the need softens something in me."
    ],
      [
      "Seeing the need softens something in me."
    ]
    ),
    action: localizedGenderNode(
      "write one word about the need.",
      "write one word about the need."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "The message that stayed",
    opening: localizedGenderNode(
      [
      "Today I notice the messages the child absorbed.",
      "Without judgment.",
      "Just truth."
    ],
      [
      "Today I notice the messages the child absorbed.",
      "Without judgment.",
      "Just truth."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What message stayed in me since then?",
      "How does that message affect me today?",
      "What would I want to replace in it?"
    ],
      [
      "What message stayed in me since then?",
      "How does that message affect me today?",
      "What would I want to replace in it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "An old message asks for a gentle repair."
    ],
      [
      "An old message asks for a gentle repair."
    ]
    ),
    action: localizedGenderNode(
      "write one gentle word instead of the message.",
      "write one gentle word instead of the message."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Being with it",
    opening: localizedGenderNode(
      [
      "Today I practice being with the child for a moment.",
      "Not to fix.",
      "Just to be."
    ],
      [
      "Today I practice being with the child for a moment.",
      "Not to fix.",
      "Just to be."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "I feel my heart."
    ],
      [
      "I breathe slowly.",
      "I feel my heart."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Where does it sit in me?",
      "What does it need from me now?",
      "How does it feel to be with it for a moment?"
    ],
      [
      "Where does it sit in me?",
      "What does it need from me now?",
      "How does it feel to be with it for a moment?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Being with it for a moment is already a small change."
    ],
      [
      "Being with it for a moment is already a small change."
    ]
    ),
    action: localizedGenderNode(
      "place a hand on my heart and breathe.",
      "place a hand on my heart and breathe."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "The fear of not being wanted",
    opening: localizedGenderNode(
      [
      "Today I notice the fear of not being wanted.",
      "Not to fight.",
      "Just to see."
    ],
      [
      "Today I notice the fear of not being wanted.",
      "Not to fight.",
      "Just to see."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When does this fear wake up?",
      "What does it tell me?",
      "How does it try to protect me?"
    ],
      [
      "When does this fear wake up?",
      "What does it tell me?",
      "How does it try to protect me?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Fear is asking for protection."
    ],
      [
      "Fear is asking for protection."
    ]
    ),
    action: localizedGenderNode(
      "tell myself \"I see you\".",
      "tell myself \"I see you\"."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "A small request for warmth",
    opening: localizedGenderNode(
      [
      "Today I form a small request for warmth.",
      "Not big.",
      "Small."
    ],
      [
      "Today I form a small request for warmth.",
      "Not big.",
      "Small."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe.",
      "I am here."
    ],
      [
      "I breathe.",
      "I am here."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What warmth do I miss?",
      "How can I ask for it gently?",
      "What is a small step toward it?"
    ],
      [
      "What warmth do I miss?",
      "How can I ask for it gently?",
      "What is a small step toward it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "One request can soften things."
    ],
      [
      "One request can soften things."
    ]
    ),
    action: localizedGenderNode(
      "write the request in one sentence.",
      "write the request in one sentence."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "fear",
    title: "A small moment of comfort",
    opening: localizedGenderNode(
      [
      "Today I look for a small moment of comfort.",
      "Not much.",
      "Just a little."
    ],
      [
      "Today I look for a small moment of comfort.",
      "Not much.",
      "Just a little."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When did I feel comfort recently?",
      "What allowed it to happen?",
      "What could invite another moment like that?"
    ],
      [
      "When did I feel comfort recently?",
      "What allowed it to happen?",
      "What could invite another moment like that?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small moment shifts direction."
    ],
      [
      "A small moment shifts direction."
    ]
    ),
    action: localizedGenderNode(
      "remember one such moment.",
      "remember one such moment."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "need",
    title: "A boundary that protects me",
    opening: localizedGenderNode(
      [
      "Today I check a small boundary that protects me.",
      "Not to distance.",
      "Just to protect."
    ],
      [
      "Today I check a small boundary that protects me.",
      "Not to distance.",
      "Just to protect."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "I feel my shoulders."
    ],
      [
      "I breathe slowly.",
      "I feel my shoulders."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Where do I give too much?",
      "What small boundary would ease me?",
      "How can I say it to myself?"
    ],
      [
      "Where do I give too much?",
      "What small boundary would ease me?",
      "How can I say it to myself?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small boundary protects the heart."
    ],
      [
      "A small boundary protects the heart."
    ]
    ),
    action: localizedGenderNode(
      "one boundary sentence to myself.",
      "one boundary sentence to myself."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "need",
    title: "Staying with myself",
    opening: localizedGenderNode(
      [
      "Today I practice staying with myself when the old pain rises.",
      "Not running away.",
      "Just being."
    ],
      [
      "Today I practice staying with myself when the old pain rises.",
      "Not running away.",
      "Just being."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What helps me stay with me?",
      "What takes me away from me?",
      "What could help me return?"
    ],
      [
      "What helps me stay with me?",
      "What takes me away from me?",
      "What could help me return?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Staying with me is a small anchor."
    ],
      [
      "Staying with me is a small anchor."
    ]
    ),
    action: localizedGenderNode(
      "one breath each time the feeling rises.",
      "one breath each time the feeling rises."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "One clear request",
    opening: localizedGenderNode(
      [
      "Today I form one clear request for myself.",
      "Not big.",
      "Clear."
    ],
      [
      "Today I form one clear request for myself.",
      "Not big.",
      "Clear."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe.",
      "I am here."
    ],
      [
      "I breathe.",
      "I am here."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What do I need right now to feel wanted?",
      "How can I ask for it gently?",
      "What is a small step toward it?"
    ],
      [
      "What do I need right now to feel wanted?",
      "How can I ask for it gently?",
      "What is a small step toward it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "One clear request can calm me."
    ],
      [
      "One clear request can calm me."
    ]
    ),
    action: localizedGenderNode(
      "write the request in one sentence.",
      "write the request in one sentence."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "perspective",
    title: "One value that holds me",
    opening: localizedGenderNode(
      [
      "Today I look for one value that holds me.",
      "Small.",
      "But true."
    ],
      [
      "Today I look for one value that holds me.",
      "Small.",
      "But true."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Which value truly matters to me?",
      "How does that value look on an ordinary day?",
      "What small step could honor it?"
    ],
      [
      "Which value truly matters to me?",
      "How does that value look on an ordinary day?",
      "What small step could honor it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "One value can be an anchor."
    ],
      [
      "One value can be an anchor."
    ]
    ),
    action: localizedGenderNode(
      "one word that expresses the value.",
      "one word that expresses the value."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "strength",
    title: "Listening to me",
    opening: localizedGenderNode(
      [
      "Today I practice listening to me with the child.",
      "Not to push away.",
      "Just to hear."
    ],
      [
      "Today I practice listening to me with the child.",
      "Not to push away.",
      "Just to hear."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "I feel my heart."
    ],
      [
      "I breathe slowly.",
      "I feel my heart."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What do I need to hear from myself today?",
      "What do I give others that I don't give me?",
      "How can I give it to myself?"
    ],
      [
      "What do I need to hear from myself today?",
      "What do I give others that I don't give me?",
      "How can I give it to myself?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Listening to me is a small repair."
    ],
      [
      "Listening to me is a small repair."
    ]
    ),
    action: localizedGenderNode(
      "one gentle sentence to myself.",
      "one gentle sentence to myself."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "strength",
    title: "A small step of acceptance",
    opening: localizedGenderNode(
      [
      "Today I choose a small step of acceptance.",
      "No drama.",
      "A small step."
    ],
      [
      "Today I choose a small step of acceptance.",
      "No drama.",
      "A small step."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What small step am I willing to try?",
      "What will feel safe enough?",
      "How will it protect me?"
    ],
      [
      "What small step am I willing to try?",
      "What will feel safe enough?",
      "How will it protect me?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small step is enough to move."
    ],
      [
      "A small step is enough to move."
    ]
    ),
    action: localizedGenderNode(
      "choose one small step and remember it.",
      "choose one small step and remember it."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Return sentence",
    opening: localizedGenderNode(
      [
      "Today I choose a sentence that brings me back to inner love.",
      "When I shake.",
      "A small sentence."
    ],
      [
      "Today I choose a sentence that brings me back to inner love.",
      "When I shake.",
      "A small sentence."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe.",
      "I am here."
    ],
      [
      "I breathe.",
      "I am here."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What did I learn about this child?",
      "What is the first sign it returns?",
      "Which sentence brings me back a moment before?"
    ],
      [
      "What did I learn about this child?",
      "What is the first sign it returns?",
      "Which sentence brings me back a moment before?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "I can meet it and still stay with myself."
    ],
      [
      "I can meet it and still stay with myself."
    ]
    ),
    action: localizedGenderNode(
      "say the new sentence once.",
      "say the new sentence once."
    ),
  },
].map(buildNormalizedDay);

export const anInnerChildWhoDidnTFeelWantedLovedBlueprintEn = buildNormalizedPilotBlueprint({
  id: "an_inner_child_who_didn_t_feel_wanted_loved_14d",
  version: "tri_locale_emit_en_v1",
  durationDays: 14,
  problemKey: "an_inner_child_who_didn_t_feel_wanted_loved",
  category: "childhood_parents_past_wounds",
  journeyName: {
    he: "ילד פנימי שלא הרגיש רצוי / אהוב",
    en: "An inner child who did not feel wanted / loved",
    es: "Un niño interior que no se sintió querido / amado",
  },
  days,
});

export default anInnerChildWhoDidnTFeelWantedLovedBlueprintEn;
